import MapStepDirections from '@/domain/MapStepDirections'
import Location from '@/domain/Location'

const INDEX_OF_DIRECTIONS = 0
const INDEX_OF_LEG = 0

export default class MapDirections {
  constructor(data) {
    this.distance = data.distance
    this.duration = data.duration
    this.startLocation = data.startLocation
    this.endLocation = data.endLocation
    this.routes = data.routes
  }

  static mapFromGoogleResult(data) {
    const routeOfDirections = data.routes[INDEX_OF_DIRECTIONS].legs[INDEX_OF_LEG]

    const startLocation = new Location({
      latitude: routeOfDirections.start_location.lat(),
      longitude: routeOfDirections.start_location.lng()
    })
    const endLocation = new Location({
      latitude: routeOfDirections.end_location.lat(),
      longitude: routeOfDirections.end_location.lng()
    })

    const mapStepsOfDirections = MapStepDirections.mapFromGoogleResults(routeOfDirections.steps)

    return new MapDirections({
      distance: routeOfDirections.distance.value,
      duration: routeOfDirections.duration.value,
      routes: mapStepsOfDirections,
      startLocation,
      endLocation
    })
  }
}
